import React from "react";
import {
	MetricsContainer,
	MetricSkeleton,
	SkeletonLabel,
	SkeletonValue,
	VisuallyHidden,
	MetricsError,
} from "./styles";
import MetricCard from "../MetricCard";
import { MetricData } from "../../useOperationalDashboardViewModel";

interface MetricsHeaderProps {
	metrics: MetricData[];
	isLoading?: boolean;
	error?: string | null;
	onRetry?: () => void;
	onMetricClick: (id: string) => void;
}

const MetricsHeader: React.FC<MetricsHeaderProps> = ({
	metrics,
	isLoading = false,
	error,
	onRetry,
	onMetricClick,
}) => {
	return (
		<MetricsContainer
			aria-label="Indicadores operacionais"
			aria-busy={isLoading}
		>
			{isLoading ? (
				metrics.map((metric) => (
					<MetricSkeleton key={metric.id} aria-hidden="true">
						<SkeletonLabel />
						<SkeletonValue />
					</MetricSkeleton>
				))
			) : error ? (
				<MetricsError role="alert">
					<span>{error}</span>
					{onRetry && (
						<button type="button" onClick={onRetry}>
							Tentar novamente
						</button>
					)}
				</MetricsError>
			) : (
				metrics.map((metric) => (
					<MetricCard
						key={metric.id}
						title={metric.title}
						value={metric.value}
						unit={metric.unit}
						accentColor={metric.accentColor}
						onClick={() => onMetricClick(metric.id)}
					/>
				))
			)}
			{isLoading && (
				<VisuallyHidden role="status">Carregando indicadores</VisuallyHidden>
			)}
		</MetricsContainer>
	);
};

export default MetricsHeader;
